import SystemLogsView from '@views/Clients/SystemLogs';
import ConfirmEmail from 'views/Authentication/ConfirmEmail.js';
import Login from 'views/Authentication/Login.js';
import Register from 'views/Authentication/Register.js';
import Client from 'views/Clients/Client.js';
import Clients from 'views/Clients/Clients.js';
import Logs from 'views/Clients/LogsView';
import Dashboard from 'views/Dashboard/NTDashboard.js';
import ParameterDictionary from 'views/Parameters/ParameterDictionary.js';
import ProvisionClient from 'views/ProvisionClient/ProvisionClient.js';
import ReferenceLists from 'views/ReferenceLists/BaseReferenceLists.js';
import Role from 'views/Roles/BaseRole.js';
import Roles from 'views/Roles/BaseRoles.js';
import TemplateDictionary from 'views/Templates/TemplateDictionary.js';
import TemplateEditor from 'views/Templates/TemplateEditor.js';
import User from 'views/Users/User.js';
import Users from 'views/Users/Users.js';

// @mui/icons-material
import ReferenceIcon from '@mui/icons-material/Announcement';
import BusinessIcon from '@mui/icons-material/Business';
import DashboardIcon from '@mui/icons-material/Dashboard';
import ParametersIcon from '@mui/icons-material/FormatListBulleted';
import RoleIcon from '@mui/icons-material/LockOpen';
import AdministratorIcon from '@mui/icons-material/People';
import ReceiptIcon from '@mui/icons-material/Receipt';
import WysiwygIcon from '@mui/icons-material/Wysiwyg';

var routes = [
  {
    path: '/dashboard',
    name: 'Dashboard',
    icon: DashboardIcon,
    component: Dashboard,
    layout: '/admin',
  },
  {
    path: '/companies',
    name: 'Companies',
    icon: BusinessIcon,
    component: Clients,
    layout: '/admin',
  },
  {
    path: '/provisionclient',
    name: 'Provision Company',
    component: ProvisionClient,
    layout: '/admin',
    invisible: true,
  },
  {
    path: '/client',
    name: 'Edit Company',
    component: Client,
    layout: '/admin',
    invisible: true,
  },
  {
    path: '/logs',
    name: 'Logs',
    component: Logs,
    layout: '/admin',
    invisible: true,
  },
  {
    path: '/parameterdictionary',
    name: 'Parameter Defaults',
    icon: ParametersIcon,
    component: ParameterDictionary,
    layout: '/admin',
  },
  {
    path: '/templatedictionary',
    name: 'Receipt Templates',
    icon: ReceiptIcon,
    component: TemplateDictionary,
    layout: '/admin',
  },
  {
    path: '/templateeditor',
    name: 'Edit Template',
    component: TemplateEditor,
    layout: '/admin',
    invisible: true,
  },
  {
    path: '/basereferencelists',
    name: 'Reference Lists',
    icon: ReferenceIcon,
    component: ReferenceLists,
    layout: '/admin',
  },
  {
    path: '/baseroles',
    name: 'Roles',
    icon: RoleIcon,
    component: Roles,
    layout: '/admin',
  },
  {
    path: '/baserole',
    name: 'Edit Role',
    component: Role,
    layout: '/admin',
    invisible: true,
  },
  {
    path: '/users',
    name: 'Users',
    icon: AdministratorIcon,
    component: Users,
    layout: '/admin',
  },
  {
    path: '/system/logs',
    name: 'System Logs',
    icon: WysiwygIcon,
    component: SystemLogsView,
    layout: '/admin',
  },
  {
    path: '/user',
    name: 'Edit User',
    component: User,
    layout: '/admin',
    invisible: true,
  },
  {
    path: '/login',
    name: 'Login User',
    component: Login,
    layout: '/auth',
    invisible: true,
  },
  {
    path: '/register/:userId',
    name: 'Register User',
    component: Register,
    layout: '/auth',
    invisible: true,
  },
  {
    path: '/confirm_email',
    name: 'Confirm Email',
    component: ConfirmEmail,
    layout: '/auth',
    invisible: true,
  },
];

export default routes;
